"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.opacity = void 0;
const foundation_1 = require("../foundation");
exports.opacity = {
    ids_opacity_empty: foundation_1.foundation_opacity.opacity.opacity_0,
    ids_opacity_soft: foundation_1.foundation_opacity.opacity.opacity_10,
    ids_opacity_medium: foundation_1.foundation_opacity.opacity.opacity_50,
    ids_opacity_strong: foundation_1.foundation_opacity.opacity.opacity_80,
    ids_opacity_none: foundation_1.foundation_opacity.opacity.opacity_100,
};
//# sourceMappingURL=opacity.js.map